import { render, staticRenderFns } from "./VDataTableWordCloudWords.vue?vue&type=template&id=407250f4&scoped=true"
import script from "./VDataTableWordCloudWords.vue?vue&type=script&lang=js"
export * from "./VDataTableWordCloudWords.vue?vue&type=script&lang=js"
import style0 from "./VDataTableWordCloudWords.vue?vue&type=style&index=0&id=407250f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407250f4",
  null
  
)

export default component.exports